import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import CampaignIcon from '@mui/icons-material/Campaign';
import { useTranslation } from 'react-i18next';
import { feedback } from '../../sentry';

export const FeedbackWidgetButton = () => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const { t } = useTranslation('common');
    useEffect(() => {
        if (buttonRef.current) {
            return feedback.attachTo(buttonRef.current, {
                showBranding: false,
                formTitle: t('Report a Problem!'),
                submitButtonLabel: t('Send Report'),
                messagePlaceholder: t(
                    "What's the problem? What did you expect?"
                ),
            });
        }
        return () => {};
    }, [t]);
    return (
        <Button
            ref={buttonRef}
            startIcon={<CampaignIcon />}
            variant="text"
            color="secondary"
            sx={{
                color: '#7682A4',
            }}
        >
            {t('Report a Problem')}
        </Button>
    );
};
